// modules/estrategias/habitante_calle/utils/handleDuplicado.js
import Swal from "sweetalert2";

export function manejarErrorDuplicado(error, nombreModulo = "registro") {
  const data = error?.response?.data;
  if (error?.response?.status === 409 && data?.codigo === "DUPLICADO") {
    Swal.fire({
      icon: "warning",
      title: "Registro duplicado",
      text: data.message || `Ya existe un registro de ${nombreModulo} con ese documento.`,
      confirmButtonColor: "#d33",
    });
    return true;
  }
  return false;
}
